import React from 'react';
// import GoogleMap from '../google-map';
// import GoogleMapStaticCustom from '../google-map-static-custom';

import '../../../lib/slick-1.8.1/slick.css';
import '../../../lib/slick-1.8.1/slick-theme.css';

import '../listing-page-style.css';


import HOne from "../../h-one";
import UserForm from '../../user-form';
import AgentCard from '../../agent-card';

export default function DealScoreContactForm(props) {
        const { 
            dictionary,
            width, 
            country, 
            contactInfo, 
            selectedCountry, 
            agent, 
            analyseInfo, 
            data, 
            saveCurrentSelectedCountry,
            handleInput,
            clearForm,
            openThanksModal,

        } = props;

        //if(!analyseInfo) return (
        if(0) return (
            <div className={"DealScoreContact"}>
                <HOne title={dictionary.request_about} addclass={"xsmall"} />
  

                <UserForm
                    clearForm={clearForm}
                    contactForm={contactInfo}
                    handleInput={handleInput}
                    selectedCountry={selectedCountry}
                    width={width}
                    saveCurrentSelectedCountry={saveCurrentSelectedCountry}
                    country={country}
                    secureInfo={true}
                    dictionary={dictionary}
                    openThanksModal={openThanksModal}
                    style={{ textAlign: 'center', margin: '40px', justifyContent: 'center' }}
                />
            </div>);
        return (
            <>
                {agent ? (
                    <AgentCard
                        listing={data}
                        hugeProfile={analyseInfo?.rank != null && analyseInfo.rank < 2}
                        width={width}
                        title={'1'}
                        notes={''}
                        agent={agent}
                        date={''}
                        disableNote={true}
                    />
                )
                    : (
                        <div className={"DealScoreContact"}>
                            <HOne title={dictionary.request_about} addclass={"xsmall"} />
              

                            <UserForm
                                clearForm={clearForm}
                                contactForm={contactInfo}
                                handleInput={handleInput}
                                selectedCountry={selectedCountry}
                                width={width}
                                saveCurrentSelectedCountry={saveCurrentSelectedCountry}
                                country={country}
                                secureInfo={true}
                                dictionary={dictionary}
                                openThanksModal={openThanksModal}
                                style={{ textAlign: 'center', margin: '40px', justifyContent: 'center' }}
                            />
                        </div>)}
            </>
        )
    }
